import * as Clerk from "@clerk/clerk-react"
import { envConfig } from "config/envConfig.ts"
import { PropsWithChildren } from "react"

export const SignIn = Clerk.SignIn

export const AuthProvider = ({ children }: PropsWithChildren) => {
	return (
		<Clerk.ClerkProvider publishableKey={envConfig.clerkPublishableKey()}>
			<Clerk.ClerkLoaded>{children}</Clerk.ClerkLoaded>
		</Clerk.ClerkProvider>
	)
}

export function useAuth() {
	const { getToken, isLoaded, isSignedIn, signOut } = Clerk.useAuth()

	return { getToken, isLoaded, isSignedIn, signOut }
}
